import cn from 'classnames';
import { Wrapper } from 'src/components/Wrapper';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useHeaderPosition } from 'src/hooks/useHeaderPosition';
import { SpeechBubble2 } from 'src/uikit/icons/ContentIcons/TechIcons/General/SpeechBubble2';
import { scrollToElementWithId } from 'src/utils/scrollToElementWithId';

import s from './AnchorMenu.module.scss';

export type Anchor = {
  id: string;
  name: string;
  type?: string;
};

export interface AnchorMenuProps {
  anchors: Anchor[];
  className?: string;
  anchorLinkClassName?: string;
  wrapperClassName?: string;
  anchorListClassName?: string;
  anchorListWrapperClassName?: string;
  slug: string;
}

function PriceIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <rect
        x="1.5"
        y="1.5"
        width="13"
        height="13"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M6.25 3.39941L6.25 12.6004"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M6.75 4.2002H9.25C10.3546 4.2002 11.25 5.09563 11.25 6.2002V6.2002C11.25 7.30476 10.3546 8.2002 9.25 8.2002H4.75"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M4.75 10.2236L10.2537 10.2236"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </svg>
  );
}

export function AnchorMenu({
  anchors,
  className = '',
  anchorLinkClassName = '',
  wrapperClassName = '',
  anchorListClassName = '',
  anchorListWrapperClassName = '',
  slug,
}: AnchorMenuProps) {
  const { showHeader, headerHeight } = useHeaderPosition();
  const { clickAnalytics } = useAnalytics();

  const onClickAnchorHandler = (name: string, id: string) => {
    clickAnalytics({
      action: 'click',
      clickZone: 'body',
      clickElement: 'navbar',
      clickContent: name,
      uniqueId: `${slug}-navbar-${name}`,
      transitionType: 'inside-link',
      clickZoneCategory: 'site-body',
      transitionTypeMetrics: 'internal',
    });
    scrollToElementWithId(id);
  };

  return (
    <section
      id="anchor-menu"
      data-attribute="no_search_index"
      className={cn(s.root, className, 'anchor-menu')}
      style={{ top: `${showHeader ? headerHeight : 0}px` }}
    >
      <Wrapper className={wrapperClassName}>
        <div className={cn(s.anchorsListWrapper, anchorListWrapperClassName)}>
          <ul className={cn(s.anchorsList, anchorListClassName)}>
            {anchors.map(({ id, name, type }, index) => (
              <li
                key={index}
                className={s.anchorItem}
                onClick={() => onClickAnchorHandler(name, id)}
              >
                <div
                  className={cn(s.anchor, anchorLinkClassName, {
                    [s.anchorWithIcon]: type === 'price' || type === 'question',
                  })}
                >
                  {name}
                  {type === 'price' && (
                    <div className={s.iconWrapper}>
                      <PriceIcon className={s.icon} />
                    </div>
                  )}
                  {type === 'question' && (
                    <div className={s.iconWrapper}>
                      <SpeechBubble2 className={s.icon} />
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </Wrapper>
    </section>
  );
}
